"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var introduction;
        (function (introduction) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.currentStep = 1;
                        this.createNewDSUrl = appn.emptyString;
                        this.dataSourceRows = appn.emptyString;
                        this.saveConsentUrl = appn.emptyString;
                    }
                }
                let _initArgs;
                const _maxSteps = 8;
                let _introLocalStorageKey = '';
                function init(args) {
                    _initArgs = args;
                    _introLocalStorageKey = `productIntroState-${appn.requestProvider.id}`;
                    addEvents();
                    appn.posthog.capture('introduction_viewed', { introStep: _initArgs.currentStep });
                    if (appn.requestUser.allowUsageAnalytics === null || appn.requestUser.allowUsageAnalytics === undefined)
                        $('#usage-analytics-modal').css('display', 'flex').show();
                    if (!appn.utils.hasValue(window.location.search))
                        appn.posthog.capture('signup');
                    findCurrentStep();
                }
                index.init = init;
                function addEvents() {
                    $('.btn-product-intro-next').on('click', function (e) {
                        e.preventDefault();
                        appn.localStorage.setItem(_introLocalStorageKey, {
                            currentStep: _initArgs.currentStep + 1
                        });
                        const nextStepUrl = $(this).attr('href');
                        appn.location.navTo(nextStepUrl);
                    });
                    $('.btn-product-intro-back').on('click', function (e) {
                        e.preventDefault();
                        appn.localStorage.setItem(_introLocalStorageKey, {
                            currentStep: _initArgs.currentStep - 1
                        });
                        const nextStepUrl = $(this).attr('href');
                        appn.location.navTo(nextStepUrl);
                    });
                    $('.btn-product-intro-skip,.btn-product-intro-complete').on('click', function (e) {
                        appn.localStorage.setItem(_introLocalStorageKey, {
                            currentStep: 1
                        });
                    });
                    $('.btn-product-intro-skip').hover(function () {
                        $('.skip-message').toggleClass('show');
                    });
                    $('.create-ds').on('click', function (e) {
                        e.preventDefault();
                        const data = { name: T('My First Data Source'), items: [] };
                        $.ajax({
                            url: _initArgs.createNewDSUrl,
                            type: 'POST',
                            contentType: 'application/json, charset=utf-8',
                            data: JSON.stringify(data),
                            success: function (result) {
                                appn.location.navTo(_initArgs.dataSourceRows, [
                                    { name: 'id', value: result.Id },
                                    { name: 'isShowImport', value: true }
                                ], appn.emptyString, true);
                            },
                            error: function () { }
                        });
                    });
                    $('#btn-usage-analytics-accept, #btn-usage-analytics-decline').on('click', function (e) {
                        e.preventDefault();
                        const isAllowed = $(this).attr('id') === 'btn-usage-analytics-accept';
                        saveUsageAnalyticsConsent(isAllowed);
                    });
                }
                function saveUsageAnalyticsConsent(isAllowed) {
                    const data = { allowTracking: isAllowed };
                    $.ajax({
                        headers: appn.verifyHeader,
                        url: _initArgs.saveConsentUrl,
                        data: data,
                        type: 'POST',
                        contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                        dataType: 'json',
                        success: function () {
                            appn.requestUser.allowUsageAnalytics = isAllowed;
                            $('#usage-analytics-modal').fadeOut();
                            if (isAllowed)
                                appn.posthog.capture('introduction_viewed', { introStep: _initArgs.currentStep });
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            if (!errorThrown || textStatus === 'parsererror')
                                errorThrown = appn.strings.errorRetrievingData;
                            appn.toast.notify(appn.toast.Type.error, errorThrown);
                        }
                    });
                }
                function findCurrentStep() {
                    var introState = appn.localStorage.getItem(_introLocalStorageKey);
                    if (!appn.utils.hasValue(introState)) {
                        introState = {
                            currentStep: 1
                        };
                    }
                    if (introState.currentStep >= _maxSteps)
                        return;
                    let url = `${appn.urls.introduction.index}?step=${introState.currentStep}`;
                    if (appn.location.urlContains(appn.urls.introduction.index))
                        if (!appn.location.urlContains(`step=${introState.currentStep.toString()}`))
                            appn.location.navTo(url);
                }
                index.findCurrentStep = findCurrentStep;
            })(index = introduction.index || (introduction.index = {}));
        })(introduction = views.introduction || (views.introduction = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
